import type { Sites } from '@studio/types';

const initialSiteFormState: Sites.Components.FormInitialState = {
  url: '',
  branding: {
    mode: 'dark',
  },
  description: '',
  isPasscodeProtected: false,
  liveWebChannel: '',
  name: '',
  passcode: '',
  passcodeHelpText: '',
  playlists: [],
  isUrlAvailable: true,
};

export default initialSiteFormState;
